import React, { createContext, useReducer, useEffect } from 'react';
import { loginAdmin } from '../api/authApi';

const AuthContext = createContext();

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  loading: true,
};

const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        loading: false,
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
        loading: false,
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const userJson = localStorage.getItem('adminUser');
    const loginTime = localStorage.getItem('adminLoginTime');
    let user = null;
    try { user = userJson ? JSON.parse(userJson) : null; } catch (e) { user = null; }

    console.log('AuthContext init', { tokenExists: !!token, user, loginTime });
    if (token && user) {
      dispatch({ type: 'LOGIN_SUCCESS', payload: { token, user } });
      // start session expiry watcher
      startExpiryWatcher(token);
    } else {
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  }, []);

  const startExpiryWatcher = (token) => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp;
      const now = Math.floor(Date.now() / 1000);
      if (exp && exp <= now) {
        logout();
        return;
      }
      const ms = (exp - now) * 1000 + 500;
      setTimeout(() => {
        console.log('Session expired, logging out');
        logout();
      }, ms);
    } catch (e) {
      // invalid token format — logout
      logout();
    }
  };

  const login = async (credentials) => {
    try {
      const response = await loginAdmin(credentials);
      console.log('AuthContext login response', response);
      // axiosClient unwraps ApiResponse so data sits under response.data
      const { token, user: userData, admin } = response.data;
      console.log('AuthContext extracted payload', { token, userData, admin });
      const source = userData || admin;
      const user = source ? { id: source.id, email: source.email, name: source.name } : null;

      localStorage.setItem('adminToken', token);
      localStorage.setItem('adminUser', JSON.stringify(user));
      localStorage.setItem('adminLoginTime', Date.now().toString());
      console.log('Token stored in localStorage', token);
      console.log('User stored in localStorage', user);

      dispatch({ type: 'LOGIN_SUCCESS', payload: { token, user } });
      startExpiryWatcher(token);
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Login failed';
      console.error('AuthContext login failed', message, error);
      return { success: false, error: message };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('adminLoginTime');
    dispatch({ type: 'LOGOUT' });
    window.location.href = '/admin/login';
  };

  return (
    <AuthContext.Provider value={{ ...state, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
